export default function StarPlatinum(props) {
  const { width, height } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1572 20.1192C10.4538 20.0147 10.684 19.7767 10.7785 19.4767L13.784 9.93933C13.9152 9.52301 14.3013 9.23989 14.7378 9.23989H15.3429C15.7794 9.23989 16.1655 9.52301 16.2967 9.93932L19.3022 19.4767C19.3968 19.7767 19.6269 20.0147 19.9235 20.1192L28.9132 23.2889C29.3132 23.4299 29.5807 23.8079 29.5807 24.232V25.0079C29.5807 25.432 29.3132 25.81 28.9132 25.951L19.9235 29.1206C19.6269 29.2252 19.3968 29.4632 19.3022 29.7632L16.2967 39.3006C16.1655 39.7169 15.7794 40 15.3429 40H14.7378C14.3013 40 13.9152 39.7169 13.784 39.3006L10.7785 29.7632C10.684 29.4632 10.4538 29.2252 10.1572 29.1206L1.16748 25.951C0.767513 25.81 0.5 25.432 0.5 25.0079V24.232C0.5 23.8079 0.767513 23.4299 1.16748 23.2889L10.1572 20.1192Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.266 5.68192C29.5626 5.57735 29.7927 5.33934 29.8872 5.03939L31.2549 0.699437C31.3861 0.28312 31.7722 0 32.2087 0H32.8138C33.2503 0 33.6363 0.283121 33.7675 0.699437L35.1352 5.03939C35.2297 5.33934 35.4598 5.57735 35.7564 5.68192L39.8325 7.11908C40.2325 7.2601 40.5 7.63808 40.5 8.06218V8.8381C40.5 9.2622 40.2325 9.64018 39.8325 9.7812L35.7564 11.2184C35.4598 11.3229 35.2297 11.5609 35.1352 11.8609L33.7675 16.2008C33.6363 16.6172 33.2503 16.9003 32.8138 16.9003H32.2087C31.7722 16.9003 31.3861 16.6172 31.2549 16.2008L29.8872 11.8609C29.7927 11.5609 29.5626 11.3229 29.266 11.2184L25.1899 9.7812C24.7899 9.64018 24.5224 9.2622 24.5224 8.8381V8.06218C24.5224 7.63808 24.7899 7.2601 25.1899 7.11908L29.266 5.68192Z"
        fill="white"
      />
    </svg>
  )
}
